import Laberint from './laberint'
import Graella from './graella'
import Continguts from './Continguts'

/* global fullpage */
/* global continguts_futurs */
/* global Cookies */

class Futurs {

	constructor() {
		this.x = 0;
		this.y = 0;
		this.wlx = 4;
		this.wly = 3;

		this.continguts = new Continguts(continguts_futurs, this);

		this.fullpage_el = document.querySelector("#fullpage");
		this.crear_laberint();
	}

	crear_laberint() {
		// Central (la creem primer per agafar els continguts)
		new Graella(this.fullpage_el.children.item(1).children.item(1), new Laberint(this.x, this.y, this.wlx, this.wly), this);

		// Superior i inferior
		new Graella(this.fullpage_el.children.item(0), new Laberint(this.x, this.y - 1, this.wlx, this.wly), this);
		new Graella(this.fullpage_el.children.item(2), new Laberint(this.x, this.y + 1, this.wlx, this.wly), this);

		// Esquerra i dreta
		new Graella(this.fullpage_el.children.item(1).children.item(0), new Laberint(this.x - 1, this.y, this.wlx, this.wly), this);
		new Graella(this.fullpage_el.children.item(1).children.item(2), new Laberint(this.x + 1, this.y, this.wlx, this.wly), this);
	}

	create() {
		const self = this;

		self.fullpage_api = new fullpage('#fullpage', {
			licenseKey: 'ACBDD2AA-18B74A34-B6F4E386-1F37025F',
			slidesNavigation: false,
			controlArrows: false,
			loopHorizontal: false,
			scrollingSpeed: 1400,
			keyboardScrolling: false,

			afterLoad: function(origin, destination, direction){
				// console.log("afterLoad", origin, destination, direction);

				if (direction != null) {

					self.fullpage_api.destroy('all');

					// Marquem l'slide destinació com activa
					destination.item.classList.add("active");

					if (direction === "up") {
						self.y -= 1;

						// Eliminem l'última section
						const lastChild = origin.item.parentNode.querySelector(".section:last-child");
						origin.item.parentNode.removeChild(lastChild);

						// Afegim un slide al principi
						const newSection = document.createElement('div');
						newSection.classList.add("section");
						destination.item.before(newSection);
					} else if (direction === "down") {
						self.y += 1;

						// Eliminem la primera section
						const firstChild = origin.item.parentNode.querySelector(".section:first-child");
						origin.item.parentNode.removeChild(firstChild);

						// Afegim una section al final
						const newSection = document.createElement('div');
						newSection.classList.add("section");
						destination.item.after(newSection);
					}

					// Afegim slides a la section actual
					destination.item.innerHTML = "";
					for(let i=0; i<3; i++) {
						const newSlide = document.createElement('div');
						newSlide.classList.add("slide");
						if (i === 1) {
							newSlide.classList.add("active");
						}
						destination.item.appendChild(newSlide);
						// console.log(destination.item);
					}

					// Refem totes les parts del laberint (podríem re-aprofitar-ne dues, però no val la pena)
					self.crear_laberint();

					// Marquem la secció del mig com a activa
					self.fullpage_el.children.item(1).classList.add("active");

					self.create();
				}
			},
			afterSlideLoad: function(section, origin, destination, direction) {
				// console.log("afterSlideLoad", section, origin, destination, direction);

				self.fullpage_api.destroy('all');

				// Marquem l'slide destinació com activa
				destination.item.classList.add("active");

				if (direction === "left") {
					self.x -= 1;

					// Eliminem l'últim slide
					const lastChild = origin.item.parentNode.querySelector(".slide:last-child");
					origin.item.parentNode.removeChild(lastChild);

					// Afegim un slide a l'esquerra
					const newSlide = document.createElement('div');
					newSlide.classList.add("slide");
					destination.item.before(newSlide);
				} else if (direction === "right") {
					self.x += 1;

					// Eliminem el primer slide
					const firstChild = origin.item.parentNode.querySelector(".slide:first-child");
					origin.item.parentNode.removeChild(firstChild);

					// Afegim un slide a la dreta
					const newSlide = document.createElement('div');
					newSlide.classList.add("slide");
					destination.item.after(newSlide);
				}

				// Refem totes les parts del laberint
				self.crear_laberint();

				// Marquem la secció del mig com a activa
				self.fullpage_el.children.item(1).classList.add("active");

				self.create();
			},
		});

		self.fullpage_api.setAllowScrolling(false);
	}

	move_up() {
		this.fullpage_api.moveSectionUp();
	}

	move_down() {
		this.fullpage_api.moveSectionDown();
	}

	move_left() {
		this.fullpage_api.moveSlideLeft();
	}

	move_right() {
		this.fullpage_api.moveSlideRight();
	}

	visita(id) {

		const visitats_json = Cookies.get('visitats');
		let visitats = [];
		if (typeof visitats_json !== 'undefined') {
			visitats = JSON.parse(visitats_json)
		}
		visitats.push(id);
		Cookies.set('visitats', JSON.stringify(visitats))
	}
}

const futurs = new Futurs();
futurs.create();